import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { MenuItem } from "@/types/menu";
import { MenuListItem } from "./MenuItem";

interface MenuSectionProps {
  title: string;
  items: MenuItem[];
  defaultExpanded?: boolean;
  className?: string;
  badge?: React.ReactNode;
}

export const MenuSection: React.FC<MenuSectionProps> = ({
  title,
  items,
  defaultExpanded = false,
  className,
  badge,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={cn("space-y-1", className)}>
      <Button
        variant="ghost"
        size="sm"
        className="w-full justify-between px-2 py-1 h-8 text-xs font-medium text-muted-foreground hover:text-foreground"
        onClick={toggleExpanded}
      >
        <div className="flex items-center">
          {isExpanded ? (
            <ChevronDown className="h-3 w-3 mr-2" />
          ) : (
            <ChevronRight className="h-3 w-3 mr-2" />
          )}
          <span>{title}</span>
        </div>
        {badge}
      </Button>
      
      {isExpanded && (
        <div className="ml-3 space-y-1">
          {items.map((item, index) => (
            <MenuListItem
              key={index}
              className={cn("text-sm", item.className)}
              {...item}
            />
          ))}
        </div>
      )}
    </div>
  );
};
